import { Reveal } from "@/components/Reveal";

export const Eyebrow = ({ index, label, dark = false }) => (
  <Reveal>
    <p
      className={`flex items-baseline gap-4 text-xs font-medium uppercase tracking-[0.28em] ${
        dark ? "text-mirian-cream/60" : "text-mirian-wine/60"
      }`}
    >
      <span
        className={`font-serif text-base normal-case italic tracking-normal ${
          dark ? "text-mirian-cream/45" : "text-mirian-wine/55"
        }`}
      >
        {index}
      </span>
      <span className={`h-px w-10 ${dark ? "bg-mirian-cream/30" : "bg-mirian-wine/30"}`} aria-hidden="true" />
      {label}
    </p>
  </Reveal>
);
